import { Divider, Grid } from "@mui/material";
import React, { useState } from "react";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { useNavigate } from "react-router-dom";
import { getPermissions } from "../../../commonFunctions/PermissionManger";
import {
    IRoleMain,
    MasterPages,
} from "../../../commonFunctions/CommonFunctions";
import { Header } from "../../../Components/Header/Header";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import { resetDataComponent } from "../../../StateManagement/actions";
import { useDispatch } from "react-redux";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";

export const ProductList: React.FC<any> = React.memo((props) => {
    const navigate = useNavigate();
    const { edit } = getPermissions(MasterPages.Users, IRoleMain.Masters);
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const dispatch = useDispatch();
    const { showMessage } = useSnackbar();

    const source = {
        url: "products/search",
        page: 1,
        pageSize: 10,
        filter: [],
        sort: []
    };

    /**
     * Edit function
     * @param action
     * @param row
     */
    const handleAction = (action: string, row: any) => {
        if (action === "Edit") {
            navigate(`/product/${row?._id}`);
        }
        if (action === "Delete") {
            setSelectedId(row._id); // Set the ID of the row to be deleted
            setPopupOpen(true);
        }
    };
    const columns: IColumns[] = [
        {
            header: "Image",
            fieldName: "imageUrl",
            tooltip: true,
            type: "img"
        },
        {
            header: "Name",
            fieldName: "name",
            tooltip: true,
            type: "default"
        },
        {
            header: "Brand",
            fieldName: "brand.name",
            tooltip: true,
            type: "default"
        },
        {
            header: "Price",
            fieldName: "price",

        },
        {
            header: "Discount Price",
            fieldName: "discountPrice",

        },
        // {
        //     header: "Stock",
        //     fieldName: "stock",

        // },
        // {
        //     header: "Available Stocks",
        //     fieldName: "isAvailable",

        // },
        {
            header: "Updated At",
            fieldName: "updatedAt",
            type: "date"
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: ["Edit", "Delete"],
            actionCallback: (action, row) => handleAction(action, row)
        }
    ];

    const handleClick = () => {
        navigate("/product/create");
    };
    const handleDelete = () => {
        dispatch(resetDataComponent("productGrid"));
        showMessage("Product deleted successfully!", "success");
    };

    return (
        <>
            {" "}
            <Grid item container spacing={2}>
                <Grid item sm={12} xs={12}>
                    <Divider />
                </Grid>
            </Grid>
            <Header
                type="simple"
                isDivider={true}
                title="Products"
                id={"productHeader"}
                headerSx={{ marginTop: 0 }}
            />
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <WSDataGrid
                        id="productGrid"
                        title="Products"
                        columns={columns}
                        source={source}
                        addButton={{ label: "New", color: "secondary" }}
                        onAddButtonClick={handleClick}
                        gridHeaderSx={{
                            backgroundColor: "whitesmoke",
                            border: "1px solid whitesmoke"
                        }}
                    />
                    {selectedId !== null && (
                        <ConfirmationPopup
                            apiUrl={"products/delete"}
                            id={selectedId}
                            confirmMessage="Are you sure you want to delete this product?"
                            open={isPopupOpen}
                            onClose={() => setPopupOpen(false)}
                            onConfirm={handleDelete}
                            permanent
                        />
                    )}
                </Grid>
            </Grid>
        </>
    );
});
